import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/questions.action'
import { getQuestionList } from 'api/administration/questions/List'

async function getList(instanceId: number) {
  return await getQuestionList(instanceId)
}

function* questionListEffectSaga(action: any) {
  try {
    const { instanceId } = action
    const data = yield call(getList, instanceId)
    yield put(fromActions.Actions.questionsListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* questionListWatcherSaga() {
  yield takeLatest(fromActions.GET_QUESTIONS_LIST, questionListEffectSaga)
}
